//* 포트폴리오 관련 API
// 2025.08.02
// 희문

import * as BaseApi from "api/Base.api";
import { ImageInfo } from "api/common/Data.api";
const BASE_URL = "/student/v2/portfolio";

export interface PortfolioInfo {
    id: number;
    title: string;
    desc: string | null;
    videoId: string;
    thumbnailImageId: string;
    thumbnailImage: ImageInfo;
    viewCount: number;
    gradeScore: number;
    isPublicToAgency: boolean;
    isPublicToKoach: boolean;
    createdAt: string;
    updatedAt: string;
}

export interface PortfolioListResult {
    list: PortfolioInfo[];
}

//* 포트폴리오 목록 조회
// 2025.08.02
// 희문
// 포트폴리오 목록 조회 시 사용
export const getPortfolioList = async (page: number, limit: number): Promise<PortfolioListResult> => {
    const url = `${BASE_URL}`;
    return await BaseApi.get(url, { page, limit });
};

//* 포트폴리오 상세 조회
// 2025.08.02
// 희문
// 포트폴리오 상세 조회 시 사용
export const getPortfolioDetail = async (id: string) => {
    const url = `${BASE_URL}/${id}`;
    return await BaseApi.get(url);
};

//* 포트폴리오 생성
// 2025.08.02
// 희문
// 포트폴리오 생성 시 사용
//* Params
export interface CreatePortfolioParams {
    title: string;
    videoId: string;
    thumbnailImageId: string;
}
export const createPortfolio = async (params: CreatePortfolioParams) => {
    const url = `${BASE_URL}`;
    return await BaseApi.post(url, params);
};

//* 포트폴리오 수정
// 2025.08.02
// 희문
// 포트폴리오 수정 시 사용
export const updatePortfolio = async (params: any) => {
    const url = `${BASE_URL}`;
    return await BaseApi.put(url, params);
};

//* 포트폴리오 삭제
// 2025.08.02
// 희문
// 포트폴리오 삭제 시 사용
export const deletePortfolio = async (params: any) => {
    const url = `${BASE_URL}`;
    return await BaseApi.remove(url, params);
};

